import React, { useEffect, useState } from "react";
import styles from "./Items.module.css"
import { Link, useNavigate } from "react-router-dom";
import { FaSearch, FaPlusCircle, FaEllipsisH, FaFileImport } from "react-icons/fa";
import DataTable from "react-data-table-component";
import axios from "axios";
import { message } from "antd";
import { Box, Button, IconButton, Tooltip } from "@mui/material";
import { DeleteOutline, EditOutlined } from "@mui/icons-material";
import DownloadCSV from "../components/DownloadItemsCSV";
import APIURL, { IMAGE_BASE_URL } from "../api/apiClient";
import AddOfferModal from "../components/ItemOfferModal";
import Loader from "../components/Loader";





const Items = () => {
    const navigate = useNavigate();
    const [records, setRecords] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filterRecords, setFilterRecords] = useState([]);
    const [visibleRowId, setVisibleRowId] = useState(false);
    const [perPage, setPerPage] = useState(10)
    const [currentPage, setCurrentPage] = useState(1)
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedItemId, setSelectedItemId] = useState(null);


    const column = [
        {
            name: "S.No",
            cell: (row, index) => (
                <div>{(currentPage - 1) * perPage + index + 1}</div>
            ),
            width: "80px",
        },
        {
            name: "Image",
            cell: (row) => {
                const imageUrl = `${IMAGE_BASE_URL}${row.image}`;
                return (
                    <div
                        style={{
                            width: "100px",
                            height: "100px",
                            overflow: "hidden",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <img
                            src={
                                imageUrl ||
                                `${IMAGE_BASE_URL}/uploads/imageplaceholder.png`
                            }
                            onError={(e) => {
                                e.target.onerror = null; // Prevents infinite loop
                                e.target.src =
                                    `${IMAGE_BASE_URL}/uploads/images/imageplaceholder.png`
                            }}
                            alt="Item image"
                            style={{
                                maxWidth: "100%",
                                maxHeight: "100%",
                                objectFit: "cover",
                                borderRadius: "8px",
                            }}
                        />
                    </div>
                );
            },
            width: "120px",
        },
        {
            name: "Name",
            selector: (row) => row.name,
            sortable: true,
            width: "250px",
        },
        {
            name: "Status",
            cell: (row) => {
                const status = Number(row.status); // now status = 0 or 1
                return (
                    <div
                        style={{
                            padding: "5px",
                            borderRadius: "5px",
                            border: "1px solid #ccc",
                            fontSize: "14px",
                            backgroundColor: status === 1 ? "#d4edda" : "#f8d7da",
                            color: status === 1 ? "#155724" : "#721c24",
                            textAlign: "center",
                        }}
                    >
                        {status === 1 ? "Active" : "Inactive"}
                    </div>
                );
            },
            width: "110px",
        },
        {
            name: "Price",
            selector: (row) => row.selling_price,
            width: "110px",
        },
        {
            name: "Stock",
            selector: (row) => row.stock,
            width: "90px",
        },
        {
            name: "Actions",
            cell: row => (
                <>
                    <Box display="flex" gap={1}>
                        <Tooltip title="Edit">
                            <IconButton
                                onClick={() => navigate(`/edit/${row.id}`)}
                                // sx={styles.editButton}
                                className={styles.editButton}
                            >
                                <EditOutlined />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete">
                            <IconButton
                                onClick={() => handleDelete(row.id)}
                                sx={styles.deleteButton}
                                className={styles.deleteButton}
                            >
                                <DeleteOutline />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </>
            ),
            width: '150px',
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
        {
            name: "Add Offer",
            width: "120px",
            cell: (row) => (
                <Button
                    variant="contained"
                    size="small"
                    color="primary"
                    onClick={() => handleOpenModal(row.id)}
                >
                    {row.offer_price ? "Change off" : "Add offer"}
                </Button>
            ),
        },
    ];

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await APIURL.get('/fetchitems.php');

                // 🧠 Normalize response into array safely
                let data = [];

                if (Array.isArray(response)) {
                    data = response; // ✅ Direct array from PHP
                } else if (
                    typeof response === "string" &&
                    response.trim().startsWith("[") &&
                    response.trim().endsWith("]")
                ) {
                    try {
                        data = JSON.parse(response); // ✅ Parse stringified array
                    } catch (err) {
                        console.error("Failed to parse stringified response:", err);
                        data = [];
                    }
                } else if (response && typeof response === "object") {
                    // ✅ Handle object responses like { data: [...], items: [...] }
                    const possibleKeys = ["data", "items", "records", "result", "rows"];
                    for (const key of possibleKeys) {
                        if (Array.isArray(response[key])) {
                            data = response[key];
                            break;
                        }
                    }
                }

                setRecords(data);
                setFilterRecords(data);
            } catch (error) {
                console.error("Failed to fetch item list:", error);
                setRecords([]);
                setFilterRecords([]);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const handleOpenModal = (id) => {
        setSelectedItemId(id);
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
        setSelectedItemId(null);
    };

    const handleFilter = (event) => {
        const newData = filterRecords.filter(row => row.name.toLowerCase().includes(event.target.value.toLowerCase()))
        setRecords(newData);
    }

    const handleDelete = async (id) => {
        const isConfirmed = window.confirm("Would you like to delete?");
        if (!isConfirmed) return;

        try {
            const response = await APIURL.delete(`/deleteitem.php?id=${id}`);

            // Normalize backend response
            const resData =
                typeof response === "string" ? JSON.parse(response.trim()) : response;

            if (resData.status === "success" || resData.success) {
                // ✅ Update the UI immediately
                setRecords((prevRecords) => prevRecords.filter((item) => item.id !== id));
                setFilterRecords((prevFilterRecords) =>
                    prevFilterRecords.filter((item) => item.id !== id)
                );

                message.success(resData.message || "Item deleted successfully.");
            } else {
                message.error(resData.message || "Failed to delete item.");
            }
        } catch (error) {
            console.error("Delete Error:", error);
            message.error("Something went wrong while deleting the item.");
        }
    };



    return (
        <div>
            <div className={styles.searchContainer}>
                <div className={styles.input_wrapper}>
                    <FaSearch className={styles.search_icon} />
                    <input placeholder="Search..." className={styles.input_search} onChange={handleFilter} />
                </div>

                <div className={styles.addnew}>
                    <Link to="/additem" className={styles.new_button}>
                        <FaPlusCircle className={styles.plus_button} /> Add Product
                    </Link>
                </div>

                {/* <div className={styles.excel}>
                    <Link to="/excelimport" className={styles.import_button}>
                        <FaFileImport /> Import Excel
                    </Link>
                </div>


                <div className={styles.excel}>
                    <Link to="/uploaditemscsv" className={styles.import_button}>
                        <FaFileImport /> Update Items
                    </Link>
                </div> 

                <DownloadCSV /> */}

            </div>
            <div className={styles.table_container}>
                <DataTable
                    title="Products"
                    columns={column}
                    data={records}
                    pagination
                    paginationPerPage={perPage}
                    onChangePage={page => setCurrentPage(page)}
                    onChangeRowsPerPage={(newPerPage, page) => {
                        setPerPage(newPerPage);
                        setCurrentPage(page);
                    }}
                    paginationRowsPerPageOptions={[10, 20, 50, 100]}
                    paginationComponentOptions={{
                        rowsPerPageText: 'Items per page:',
                        rangeSeparatorText: 'of',
                    }}
                    // ✅ This hides "No records" and shows loader
                    progressPending={loading}
                    progressComponent={<Loader type="table" loading={true} />}
                    noDataComponent={loading ? null : "No records to display"}
                    customStyles={{
                        header: {
                            style: {
                                fontSize: '24px',

                            },
                        },
                        headCells: {
                            style: {

                                color: 'gray',
                                fontSize: '20px',
                                textAlign: 'center',
                            },
                        },
                        cells: {
                            style: {
                                fontSize: '16px',
                                textAlign: 'center',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                maxWidth: '150px', // adjust as needed
                            },
                        },
                        rows: {
                            style: {
                                fontSize: '17px',
                                height: '100px',
                                overflow: 'hidden',
                                '&:hover': {
                                    backgroundColor: '#f9f9f9',
                                },
                            },
                        },
                    }}
                    className={styles.custom_table}
                />

            </div>
            {selectedItemId && (
                <AddOfferModal
                    open={modalOpen}
                    handleClose={handleCloseModal}
                    itemId={selectedItemId}
                />
            )}
        </div>

    );

};

export default Items;